import { TelasIds } from "../../../../../common/utils/tela_ids";
import { IDeleteRequisicaoCompraUseCase } from "../../../presentation/useCases/delete/delete_requisicao_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteRequisicaoCompraUseCase
 */

export class DeleteRequisicaoCompraUseCase implements IDeleteRequisicaoCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteRequisicaoCompra(
    idTela: TelasIds,
    idRequisicaoCompra: number,
  ): Promise<void> {
    await this.repository.deleteRequisicaoCompra(
      idTela,
      idRequisicaoCompra,
    );
  }
}
